import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import LegalEntitiesDt from '@/services/dataTransferModules/legalEntitiesDt'

export default function useLegalEntities() {
	const legalEntitiesDt = new LegalEntitiesDt()

	const { t: $t } = useI18n()

	const legalEntityNullableObjects = computed(() => {
		return {
			id: -1,
			name: $t('Not specified'),
		}
	})

	const {
		loadEntityFlags: flags,

		entities: fullLegalEntities,
		getEntities: getFulledLegalEntities,

		extendedEntities: extendedLegalEntities,
		getExtendedEntities: getExtendedLegalEntities,

		basedEntities: baseLegalEntities,
		getBasedEntities: getBasedLegalEntities,

		hashedBasedEntities: hashedBasedLegalEntities,
		getHashedBasedEntities: getHashedBasedLegalEntities,

		createEntity: createLegalEntity,

		entity: legalEntity,
		getEntity: getLegalEntity,

		entityPopup: legalEntityPopup,
		getEntityPopup: getLegalEntityPopup,

		entityPreview: legalEntityPreview,
		getEntityPreview: getLegalEntityPreview,

		patchEntity: updateLegalEntity,

		deleteEntity: deleteLegalEntity,
	} = useBlProviders(
		legalEntitiesDt,
		Object.assign({
			showErrorNotificationForLoadingAllEntities: true,

			showErrorNotificationForCreatingEntity: true,

			showErrorNotificationForLoadingOneEntity: true,

			showErrorNotificationForUpdatingEntity: true,

			showErrorNotificationForDeletingEntity: true,
		})
	)

	return {
		flags,
		legalEntityNullableObjects,

		fullLegalEntities,
		extendedLegalEntities,
		baseLegalEntities,
		getBasedLegalEntities,
		getExtendedLegalEntities,
		getFulledLegalEntities,

		legalEntity,
		legalEntityPopup,
		legalEntityPreview,
		getLegalEntity,
		getLegalEntityPopup,
		getLegalEntityPreview,

		createLegalEntity,
		updateLegalEntity,
		deleteLegalEntity,

		hashedBasedLegalEntities,
		getHashedBasedLegalEntities,
	}
}
